import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { scrollToId } from "../lib/site";
import { Reveal, ChapterTag, SectionTitle } from "./Reveal";
import { DynIcon } from "../lib/icons";

export function Services() {
  const { content } = useSite();
  const services = content?.services || [];

  return (
    <section id="layanan" data-testid="services-section" className="relative py-24 sm:py-32 bg-navy-900 blueprint-grid">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterTag number="02" label="Layanan Kami" />
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionTitle>Dari Perencanaan <br className="hidden sm:block" /> hingga <span className="text-ice">Perawatan</span></SectionTitle>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-steel text-base">Satu tim untuk seluruh siklus cold storage Anda: desain, fabrikasi, instalasi, hingga maintenance.</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.id || i} delay={0.06 * (i % 3)}>
              <motion.button
                data-testid={`service-card-${i}`}
                onClick={() => scrollToId("penawaran")}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.3 }}
                className="group relative w-full text-left bg-navy-950 border border-glacier/15 rounded-sm overflow-hidden hover:border-ice/50 hover:glow-ice transition-colors duration-300"
              >
                <div className="relative h-44 overflow-hidden">
                  {s.image && (
                    <img src={s.image} alt={s.title} loading="lazy" className="w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-950 to-transparent" />
                  <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.25em] text-ice/80">{String(i + 1).padStart(2, "0")}</span>
                  <span className="absolute bottom-3 right-3 w-10 h-10 rounded-sm bg-navy-950/80 border border-glacier/25 flex items-center justify-center">
                    <DynIcon name={s.icon} className="w-5 h-5 text-ice" />
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-2xl font-semibold uppercase tracking-wide text-frost flex items-center justify-between gap-3">
                    {s.title}
                    <ArrowUpRight className="w-5 h-5 text-steel group-hover:text-ice group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300 shrink-0" />
                  </h3>
                  <p className="mt-3 text-sm text-steel leading-relaxed">{s.description}</p>
                </div>
              </motion.button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
